"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getLanguageCookieKey = require("./getLanguageCookieKey");
Object.keys(_getLanguageCookieKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getLanguageCookieKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getLanguageCookieKey[key];
    }
  });
});
